import { CheckedCsvInviteUser } from '../../../store/auth/auth'
import React from 'react'
import pluralize from 'pluralize'

export interface InvitePreparationSummaryProps {
  users: CheckedCsvInviteUser[]
}

export const InvitePreparationSummary = ({ users }: InvitePreparationSummaryProps) => {
  const newInviteCount = users.filter((user) => user.inviteStatus === null).length
  const alreadyMemberCount = users.filter((user) => user.inviteStatus === 'already_member').length
  const alreadyInvitedCount = users.filter((user) => user.inviteStatus === 'already_invited').length

  const toBeInvitedCount = newInviteCount + alreadyMemberCount

  return (
    <div className='pt-3'>
      <i className='bi bi-check-circle-fill zocks-text-success pe-1' /> CSV file looks good. We are about to invite {toBeInvitedCount}{' '}
      {pluralize('user', toBeInvitedCount)}.
      <ul className='pt-2'>
        {newInviteCount ? (
          <li>
            New invitation: {newInviteCount} {pluralize('user', newInviteCount)}
          </li>
        ) : null}
        {alreadyMemberCount ? (
          <li>
            <i className='bi bi-exclamation-triangle-fill zocks-text-warning-text pe-1' />
            Already member: {alreadyMemberCount} {pluralize('user', alreadyMemberCount)} (no invitation will be sent)
          </li>
        ) : null}
        {alreadyInvitedCount ? (
          <li>
            <i className='bi bi-exclamation-triangle-fill zocks-text-warning-text pe-1' />
            Already invited: {alreadyInvitedCount} {pluralize('user', alreadyInvitedCount)} (invitation will not be sent)
          </li>
        ) : null}
      </ul>
    </div>
  )
}
